module.exports = __webpack_public_path__ + "media/anuncio_lol.46bfe272.mp3";